export const MENTORSHIP_REQUEST_STATUS_PENDING = 1;
export const MENTORSHIP_REQUEST_STATUS_APPROVED = 2;
export const MENTORSHIP_REQUEST_STATUS_REJECTED = 3;